import React from 'react'
import styled from 'styled-components'
import { Flex, Heading, useMatchBreakpoints } from 'penguinfinance-uikit2'

const StyledContainer = styled.div<{ isMobile?: boolean }>`
  display: flex;
  padding-top: ${({ isMobile }) => (isMobile ? 16 : 150)}px;
  padding-bottom: ${({ isMobile }) => (isMobile ? 16 : 40)}px;
  position: relative;
  justify-content: ${({ isMobile }) => (isMobile ? 'stretch' : 'flex-end')};
  padding-right: ${({ isMobile }) => (isMobile ? 0 : 30)}px;

  @media (max-width: 640px) {
    justify-content: center;
  }

  @media (min-width: 968px) {
    padding-top: 80px;
    padding-bottom: 40px; 
  }
  @media (min-width: 1200px) {
    padding-top: 120px;
    padding-bottom: 40px; 
  }
  @media (min-width: 1400px) {
    padding-top: 150px;
    padding-bottom: 40px; 
  }
`

const StyledButton = styled(Flex)<{ isMobile?: boolean }>`
  background-color: #ee3e40;
  color: white;
  white-space: nowrap;
  margin-bottom: 8px;
  font-weight: 300;
  font-family: 'Telegraf UltraBold Font';
  border-radius: 10px;
  padding-top: 16px;
  padding-bottom: 16px;
  height: auto;
  width: ${({ isMobile }) => (isMobile ? '100%' : 'auto')};
  height: 56px;

  img {
    margin-left: 8px;
  }

  &:last-child {
    margin-bottom: 0;
  }

  @media (min-width: 640px) {
    margin-bottom: 0;
    height: unset;
  }
  @media (min-width: 968px) {
    width: 55%;
    margin-bottom: 0;
    height: unset;
  }
  @media (min-width: 1200px) {
    font-size: 20px;
    width: 65%;
  }
`

const StyledHeading = styled(Heading)`
  font-family: Kanit;
  font-style: normal;
  font-weight: bold;
  font-size: 21px;
  line-height: 32px;
  color: #ffffff;

  @media (min-width: 640px) {
    font-size: 56px;
    line-height: 72px;
  }
  @media (min-width: 968px) {
    font-size: 40px;
    line-height: 56px;
  }
  @media (min-width: 1200px) {
    font-size: 56px;
    line-height: 72px;
  }
`

const StyledText = styled(Heading)`
  font-family: Kanit;
  font-style: normal;
  font-weight: normal;
  
  font-size: 10px;
  line-height: 15px;
  color: #ffffff;

  @media (min-width: 640px) {
    font-size: 27px;
    line-height: 40px;
  }
  @media (min-width: 968px) {
    font-size: 20px;
    line-height: 32px;
  }
  @media (min-width: 1200px) {
    font-size: 27px;
    line-height: 40px;
  }
`

const LaunchpadPefiImg = styled.img`
  position: absolute;
  top: -40px;
  left: 0;
  z-index: -1;
  width: 360px;

  @media (min-width: 1200px) {
    width: 480px;
    top: -100px;
  }
  @media (min-width: 1400px) {
    width: 520px;
    top: -100px;
  }
`;

const PlanetImg = styled.img`
  position: absolute;
  top: -40px;
  right: 0;
  z-index: -1;
  width: 360px;

  @media (min-width: 1200px) {
    width: 480px;
    top: -100px;
  }
  @media (min-width: 1400px) {
    width: 530px;
    top: -110px;
  }
`;

const LaunchPadButtonCard = () => {
  const { isXl } = useMatchBreakpoints()
  const isMobile = !isXl

  return (
    <StyledContainer isMobile={isMobile}>
      {!isMobile && (
        <>
          <LaunchpadPefiImg
            src="/images/home-v2/launchpad_pefi.svg"
            alt="launchpad_pefi"
          />
          <PlanetImg
            src="/images/home-v2/planet.svg"
            alt="planet"
          />
        </>
      )}
      <StyledButton justifyContent='center' flexDirection='column' alignItems='center' isMobile={isMobile}>
        <div>
          <StyledHeading>Launchpad</StyledHeading>
        </div>
        <div>
          <StyledText>PAST IDOS</StyledText>
        </div>
      </StyledButton>
    </StyledContainer>
  )
}

export default LaunchPadButtonCard
